
const p42_2025_fall = ["pokemon_2026_flat", "kpop_demon_2026", "minecraft", "travel", "mario_2026", "encanto"]

import React, { useContext, useEffect } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate
} from "react-router-dom";

import {
  AppBar,
  createTheme,
  IconButton,
  Toolbar,
  Typography
} from "@mui/material";
import { ThemeProvider } from "@emotion/react";
import SignIn from "./pages/SignIn/SignIn";
import Dashboard from "./pages/Dashboard/Dashboard";
import ReadPsd from "./pages/Test/TestReadPsd";
import PublishPsd from "./pages/PublishPsd/PublishPsd";
import { AppProvider } from "./provider/AppProvider";
import { AuthProvider } from "./provider/AuthProvider";
import { signOut } from "firebase/auth";
import { auth } from "./firebaseSetup";
import TestReadZip from "./pages/Test/TestReadZip";
import Config from "./components/Config/Config";
import { SettingsIcon } from "./icons";
import PhotoBoothPage from "./pages/PhotoBoothPage/PhotoBoothPage";
import MediaPipeEx from "./pages/Test/MediaPipeEx";
import { CookiesProvider } from "react-cookie";
import { ImageCacheProvider } from "./components/hooks/useImageCache";



const darkTheme = createTheme({
  palette: {
    mode: "light"
  }
});

const Logout = () => {
  const nav = useNavigate();
  useEffect(() => {
    if (auth.currentUser && !auth.currentUser?.isAnonymous) {
      console.debug("Signing out user");
      signOut(auth).then(() => window.setTimeout(nav, 1000, "/"));
    } else {
      console.debug("No need to logout anonymous user.");
    }
  }, []);
  return <Typography variant="body1">Logging out...</Typography>;
};

const WithButtons: React.FC<{
  children?: React.ReactElement;
}> = ({ children }) => {
  const nav = useNavigate();
  return children ? (
    children
  ) : (
    <>
      <Outlet />
      <div style={{ position: "fixed", top: "16px", right: "16px" }}>
        <IconButton onClick={() => nav("/config")}>
          <SettingsIcon />
        </IconButton>
      </div>
    </>
  );
};

const App = () => {
  return (
    <CookiesProvider defaultSetOptions={{ path: '/' }}>
      <AuthProvider>
        <AppProvider>
          <ImageCacheProvider >
            <ThemeProvider theme={darkTheme}>
              <Router>
                <Routes>
                  {/* Camera Config */}
                  <Route path="/config" element={<Config />} />

                  {/* Selection Home */}
                  <Route element={<WithButtons />}>
                    <Route path="/" element={<Dashboard templates={p42_2025_fall} />} />
                    <Route path="/p42" element={<Dashboard templates={p42_2025_fall} />} />
                    <Route path="/42" element={<Dashboard templates={p42_2025_fall} />} />
                  </Route>

                  {/* Main Photobooth */}
                  <Route
                    path="ps42/:templateName"
                    element={<PhotoBoothPage />}
                  />
                  <Route path="/testzip" element={<TestReadZip />} />
                  <Route path="/publish" element={<PublishPsd />} />
                  <Route path="/mediapipex" element={<MediaPipeEx />} />
                </Routes>
              </Router>
            </ThemeProvider>
          </ImageCacheProvider>
        </AppProvider>
      </AuthProvider>
    </CookiesProvider>
  );
};

export default App;
